import React from "react";

import BillingAmountInput from "components/pages/billingAmount/form/BillingAmountInput";

const BillingAmountInputForm = (props) => {
  const { formikProps } = props;
  const { values } = formikProps;

  return (
    <form style={{ minWidth: "500px" }}>
      {values?.billing?.map((billingItem, billingItemIndex) => (
        <BillingAmountInput
          key={billingItemIndex}
          index={billingItemIndex}
          formikProps={formikProps}
          billingItem={billingItem}
        />
      ))}
    </form>
  );
};

export default BillingAmountInputForm;
